import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChipSharedComponent } from './chip.component';
import { IconSharedModule } from './../../atoms/icon/icon.module';

@NgModule({
    declarations: [
        ChipSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule
    ],
    exports: [
        ChipSharedComponent
    ]
})

export class ChipSharedModule {}
